// TODO: think about moving those into the types folder

export const SA_SELLER_ID: string = 'shop-apotheke'
export const SA_SELLER_NAME: string = 'SHOP APOTHEKE'

export const ORDER_TYPE: {
  NORMAL: string
  SUBSCRIPTION: string
  FREIGHT: string
} = {
  NORMAL: 'NORMAL',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FREIGHT: 'FREIGHT'
}

export enum SHIPPING_TYPE {
  'carrier.her.001' = 'HERMES',
  'carrier.dhl.001' = 'DHL',
  'carrier.the.001' = 'THERMOMED'
}

export enum DOCUMENT_TYPE {
  PRIVATE_PRESCRIPTION = 'privatePrescription',
  FREE_PRESCRIPTION = 'freePrescription',
  INSURANCE_PRESCRIPTION = 'insurancePrescription',
  NO_PRESCRIPTION = 'noPrescription',
  ODS_SECTION = 'odsSection'
}

export enum ENTRY_TYPE {
  ARTICLE = 'article',
  SERVICE = 'service'
}

export const ADYEN_PAYMENT_DATA_LOCAL_STORAGE_KEY = 'paymentData'

export const PHONE_NUMBER_MODAL = 'phone-number-modal'
